/**
 *   * this create setlist popup effect
 *   **/
import $ from 'jquery';

export const setlistPopup = () => {
	/*
	$("a.tmot-table-column-livepass").on("click", function(e){
    		 	var selItem = $(this);
			if(selItem.hasClass('active')){
				selItem.parent().removeClass('active');
				selItem.removeClass('active');
			}else{
        			selItem.siblings().removeClass('active');
        			selItem.addClass('active');
				selItem.parent().addClass('active');
			}
    			e.stopPropagation();
	});

	var modal = document.getElementByClassName(".setList.active");
	var span = document.getElementsByClassName("close")[0];

	span.onclick = function() {
  		modal.style.display = "none";
	}

	// When the user clicks anywhere outside of the modal, close it
	window.onclick = function(event) {
		if (event.target == modal) {
	      		modal.style.display = "none";
		}
        }
	*/
	$("a.btn-setlist").on("click", function(e){
		var selItem = $(this);
		$('.l-pageContainer').css('height','0');
		if(selItem.hasClass('active')){
			selItem.parent().removeClass('active');
			//selItem.removeClass('active');
		}else{
			selItem.siblings().removeClass('active');
			//selItem.addClass('active');
			selItem.parent().addClass('active');
			$('.setList.active > .modal').show();
    }
    e.stopPropagation();			
	});

	$(".close").click(function(e){
    e.stopPropagation();
		$('.modal').hide();
		$('.l-pageContainer').css('height','inherit');
		if($( ".setList" ).hasClass( "active" )){
    	$('.setList').removeClass('active');
    }
		if($("a.btn-setlist").hasClass( "active" )){
			$("a.btn-setlist").hasClass( "active" )
		}
	});

}

